var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyResultPieBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.062.609A8 8 0 0012 0v8h8A7.999 7.999 0 0015.062.609z",
    fill: "#0072AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.055V10h7.945a9.098 9.098 0 010 2A9.001 9.001 0 118 2.055a9.098 9.098 0 012 0zM8 12h7.93A7.001 7.001 0 012 11a7.002 7.002 0 016-6.93V12z",
    fill: "#0072AB"
  })));
}
export default SvgKeyResultPieBlue;